/**
 * Lazy loads styles for elements with data-lazy-style attribute
 * Observes elements and applies styles when they become visible
 */
export function initLazyStyleLoading(): void {
  const lazyStyleAttrName = 'data-lazy-style';
  
  const observeVisibility = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry: IntersectionObserverEntry) => {
      if (entry.isIntersecting) {
        const el = entry.target as HTMLElement;
        observeVisibility.unobserve(el);
        
        const lazyStyles = el.getAttribute(lazyStyleAttrName);
        if (lazyStyles) {
          el.setAttribute('style', lazyStyles);
          el.removeAttribute(lazyStyleAttrName);
        }
      }
    });
  }, { 
    threshold: 0,
    rootMargin: '0px 0px 30% 0px'
  });

  document.querySelectorAll(`div[${lazyStyleAttrName}]`).forEach((el: Element) => {
    observeVisibility.observe(el);
  });
}

/**
 * Initialize lazy style loading after the DOM is loaded
 */
function setupLazyStyleLoading(): void {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyStyleLoading);
  } else {
    // DOM is already loaded
    initLazyStyleLoading();
  }
}

// Auto-initialize when module is imported
setupLazyStyleLoading();
